import React from 'react';
import { StudentForm } from './StudentForm';

const SquareShape: React.FC = () => (
  <div 
    className="w-full h-full bg-white transform rotate-15"
  />
);

export const StudentSquare: React.FC = () => {
  return (
    <StudentForm
      backgroundColor="#EE5E37"
      ShapeIcon={SquareShape}
    />
  );
};